import { useState } from "react";
import { toast } from "react-toastify";
import { exportCarOrdersCSV, exportCarOrdersPDF } from "../services/useService";
import { notifyError, notifySuccess } from "src/assets/toastService";
import { Order } from "src/shared/services/interfacev2";

export const useExportCarOrders = (orders: Order[]) => {
  const [loadingExport, setLoadingExport] = useState(false);

  const handleDownload = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = event.target.value;
    const query = orders.map((data) => `order_id=${encodeURIComponent(data.orderId)}`).join("&");
    setLoadingExport(true);

    try {
      if (selectedOption === "csv") {
        const response = await exportCarOrdersCSV(query);
        if (response.status === 201) {
          notifySuccess("CSV email sent successfully");
        } else {
          toast.error("Failed to send CSV email");
        }
      } else if (selectedOption === "pdf") {
        const response = await exportCarOrdersPDF(query);
        if (response.status === 201) {
          notifySuccess("PDF email sent successfully");
        } else {
          notifyError("Failed to send PDF email");
        }
      }
    } catch (error) {
      console.error("Error exporting file:", error);
      notifyError("Error exporting file. Please try again.");
    } finally {
      setLoadingExport(false);
    }
  };

  return { handleDownload, loadingExport };
};
